import map from "lodash/fp/map";
import assign from "lodash/fp/assign";
import isNil from "lodash/fp/isNil";

class CaptainsPageTransform {
  constructor() {
    "ngInject";

    // NOTE: name is used for (user roles)
    this.item = {
      title: "Captain",
      state: "captain",
      name: "captain",
    };

    this.fields = [
      { title: "Name", name: "name", isSortable: true },
      { title: "Phone", name: "phone" },
      { title: "City", name: "city" },
      { title: "Company", name: "company" },
      { title: "Contractor", name: "contractor" },
      { title: "Active", name: "active" },
      { title: "Rating", name: "rating", isSortable: true },
    ];

    this.filters = [
      {
        name: "search",
        title: "Search",
        icon: "search",
        isSearch: true,
        resource: "Captain",
        state: "captain",
        size: 30,
      },
      { name: "city", title: "City", icon: "location_city", resource: "City" },
      {
        name: "company",
        title: "Company",
        icon: "business",
        resource: "Company",
      },
    ];

    this.addOptions = {
      title: "Add New Captain",
      icon: "add",
      fields: [
        {
          resource: "City",
          name: "city",
          title: "City",
          isResource: true,
          isRequired: true,
        },
        {
          name: "name_i18n",
          title: "Name",
          type: "text",
          isI18nText: true,
          isRequired: true,
        },
        {
          name: "phone_data",
          title: "Phone",
          type: "number",
          isPhoneObject: true,
          isRequired: true,
        },
        {
          name: "national_id",
          title: "National Id",
          isText: true,
          isRequired: true,
          pattern: "\\d+",
          patternErrorMsg: "This field only supports numbers",
        },
        {
          resource: "Contractor",
          name: "contractor",
          title: "Contractor",
          isResource: true,
          isRequired: false,
          renderIf: "!{{company}}.value",
        },
        {
          resource: "Company",
          name: "company",
          title: "Company",
          isResource: true,
          isRequired: false,
          renderIf: "!{{contractor}}.value",
        },
        {
          name: "is_tax_filer",
          title: "Tax Filer",
          value: null,
          list: "taxFilers",
          isRequired: false,
        },
        {
          name: "license",
          title: "License",
          type: "text",
          isText: true,
          isRequired: true,
        },
        { name: "notes", title: "Notes", isTextarea: true, isRequired: false },
      ],
    };
  }

  justify(data) {
    const getSource = (item) => {
      item = assign({ _id: item._id }, item._source);
      item.rating = item.rating.toFixed(2);
      item.contractor =
        !isNil(item.contractor) && !isNil(item.contractor.name_i18n)
          ? item.contractor.name_i18n.en
          : "No Contractor";

      return item;
    };

    return map(getSource)(data);
  }
}

export default CaptainsPageTransform;



// WEBPACK FOOTER //
// ./src/pages/captains/captains.transforms.js